<template>
	<c-dialog ref="dialog" title="商品上架" width="500" @resolve="submit">
		<div class="shelf-product-info" v-if="productData.channel_product_id">
			<p>商品编码：{{productData.produce_unique_code}}</p>
			<p>商品信息：{{productData.product_info}}</p>
			<p>成本价：¥{{formatPrice(productData.cost_price)}}</p>
			<p>上架渠道：{{productData.channel_name}}</p>
		</div>
		<div class="shelf-price-row">
			<label class="shelf-price-label"><span class="req">*</span>销售价：</label>
			<c-input v-model="salePrice" type="number" decimal="2" :range="[0, 99999999]" placeholder="请输入销售价" append-text="元" :clear="false" style="width: 240px;"></c-input>
		</div>
	</c-dialog>
</template>

<script>
	export default {
		name: 'saleShelfChannel',

		data() {
			return {
				productData: {},
				salePrice: ''
			}
		},

		methods: {
			open(data) {
				this.productData = data || {};
				// 默认销售价为上次价格（行上的 sale_price）
				this.salePrice = this.productData.sale_price != null ? this.productData.sale_price : '';
				this.$refs.dialog.open();
			},

			formatPrice(val) {
				return parseFloat(val || 0).toFixed(2);
			},

			/*********提交上架（按渠道商品ID操作）**********/
			submit(stop, next) {
				stop();
				let price = parseFloat(this.salePrice);
				if (isNaN(price) || price <= 0) {
					this.$message({message: '请填写销售价', type: 'warn'});
					return;
				}
				this.request({
					url: '/mall/product/onShelf',
					data: {
						channel_product_id: this.productData.channel_product_id,
						sale_price: price
					},
					loading: true,
					success: (data, msg) => {
						next();
						this.$message({message: msg || '上架成功', type: 'success'});
						this.$emit('resolve');
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.shelf-product-info {
		margin-bottom: 16px;
		p {
			margin: 4px 0;
			color: #666;
		}
	}
	.shelf-price-row {
		display: flex;
		align-items: center;
		.shelf-price-label {
			width: 90px;
			.req {
				color: #f56c6c;
				margin-right: 2px;
			}
		}
	}
</style>
